import React, { useState, useEffect, useRef } from "react";
import AIImage from "../../../../img/aiagent.png";
import { Badge, Form } from "react-bootstrap";
import { BsFillSendFill, BsCheck2All } from "react-icons/bs";

const getDayLabel = (date) => {
  const today = new Date();
  const msgDate = new Date(date);
  const diffDays = Math.floor((today - msgDate) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) return `${diffDays} days ago`;

  return msgDate.toLocaleDateString([], {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const AskAI = ({ isFullScreenMode, isFullScreen, setIsFullScreen }) => {
  const [messages, setMessages] = useState([
    {
      sender: "ai",
      text: "Hi there! How can I assist you today?",
      time: new Date(),
      status: "read",
    },
  ]);
  const [input, setInput] = useState("");
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSend = () => {
    if (!input.trim()) return;

    const now = new Date();

    const newMessages = [
      ...messages,
      { sender: "user", text: input, time: now, status: "sent" },
    ];
    setMessages(newMessages);
    setInput("");

    setTimeout(() => {
      const aiTime = new Date();
      setMessages((prev) => [
        ...prev.map((m) =>
          m.sender === "user" ? { ...m, status: "read" } : m
        ),
        {
          sender: "ai",
          text: "This is a sample AI reply.",
          time: aiTime,
          status: "read",
        },
      ]);
    }, 1200);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const groupedMessages = messages.reduce((groups, msg) => {
    const dateKey = new Date(msg.time).toDateString();
    if (!groups[dateKey]) groups[dateKey] = [];
    groups[dateKey].push(msg);
    return groups;
  }, {});

  return (
    <div className="overflow-hidden w-100 d-flex flex-column">
      <div
        className="justify-content-between toolbar border-bottom hstack w-100 bg-light p-1"
        style={{ height: 35 }}
      >
        <div className="hstack gap-2">
          <img src={AIImage} alt="Ask AI" style={{ width: 24 }} />
          <h6 className="m-0">Ask AI</h6>
        </div>
        <div className="hstack gap-1">
          <i
            title={`${isFullScreen ? "Minimize" : "Maximize"} Console`}
            className={`fa-solid ${
              isFullScreen ? "fa-minimize" : "fa-maximize"
            } CP`}
            onClick={() => setIsFullScreen(!isFullScreen)}
          />
        </div>
      </div>

      <div
        className="overflow-auto flex-grow-1 p-2"
        style={{
          height: isFullScreenMode
            ? "calc(100vh - 150px)"
            : "calc(100vh - 295px)",
        }}
      >
        {Object.keys(groupedMessages).map((dateKey) => (
          <div key={dateKey}>
            <div className="text-center mb-2">
              <Badge bg="secondary" className="px-2" style={{ fontSize: 10 }}>
                {getDayLabel(dateKey)}
              </Badge>
            </div>

            {groupedMessages[dateKey].map((msg, index) => (
              <div
                key={index}
                className={`d-flex mb-2 ${
                  msg.sender === "user"
                    ? "justify-content-end"
                    : "justify-content-start"
                }`}
              >
                {msg.sender === "ai" && (
                  <img
                    src={AIImage}
                    alt="AI"
                    className="rounded-circle me-2"
                    style={{ width: 24, height: 24 }}
                  />
                )}

                <div
                  className={`p-2 rounded-3 position-relative ${
                    msg.sender === "user"
                      ? "selectedMenu"
                      : "bg-light text-dark"
                  }`}
                  style={{ maxWidth: "75%", wordBreak: "break-word" }}
                >
                  <div style={{ fontSize: 12 }}>{msg.text}</div>
                  <div
                    className={`d-flex align-items-center gap-1 mt-1 ${
                      msg.sender === "user" ? "selectedMenu" : "text-muted"
                    }`}
                    style={{ fontSize: "0.75rem", justifyContent: "flex-end" }}
                  >
                    <span style={{ fontSize: 10 }}>
                      {new Date(msg.time).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                    {msg.sender === "user" && (
                      <BsCheck2All
                        size={14}
                        color={msg.status === "read" ? "#005effff" : "#000"}
                        title={msg.status === "read" ? "Seen" : "Message sent"}
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
        <div ref={chatEndRef} />
      </div>

      <div className="position-relative">
        <Form.Control
          as="textarea"
          rows={2}
          placeholder="Type here..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          style={{ resize: "none" }}
          className="border-0 border-top rounded-0"
        />
        <div
          className="position-absolute end-0 bottom-0 p-2 CP"
          title="Send"
          onClick={handleSend}
        >
          <BsFillSendFill size={18} />
        </div>
      </div>
    </div>
  );
};

export default AskAI;
